import React, { useRef, useState, useEffect } from 'react';
import cx from 'classnames';
import { useSvgLines } from './utils/useSvgLines.js';
import styles from './index.module.scss.js';

const LinkCollectionLines = ({
  className,
  style,
  listRef,
  activeIndex,
  isShown
}) => {
  const svgRef = useRef(null);
  const [refElements, setRefElements] = useState([]);
  useEffect(
    () => setRefElements(
      Array.from(listRef.current?.querySelectorAll(".js-item") ?? [])
    ),
    [listRef]
  );
  const { width, height, lines } = useSvgLines({
    svgRef,
    refElements
  });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      ref: svgRef,
      className: cx(styles.box, className),
      style,
      width,
      height,
      viewBox: `0 0 ${width} ${height}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": true
    },
    lines.map(({ key, path, length }) => /* @__PURE__ */ React.createElement(
      "path",
      {
        key: `static-${key}`,
        d: path,
        strokeWidth: 1,
        stroke: "currentColor",
        style: {
          strokeDasharray: `${isShown ? length : 0}px ${length}`
        }
      }
    )),
    lines.map(({ key, path, length }, index) => /* @__PURE__ */ React.createElement(
      "path",
      {
        className: styles.active,
        key: `active-${key}`,
        d: path,
        strokeWidth: 1,
        stroke: "currentColor",
        style: {
          strokeDasharray: `${index <= activeIndex ? length : 0}px ${length}`
        }
      }
    ))
  );
};

export { LinkCollectionLines };
//# sourceMappingURL=index.js.map
